import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'currentUser';
const LOGIN_KEY = 'login-token';
const Company_KEY = 'company-token';

@Injectable({
  providedIn: 'root'
})

export class TokenStorageService {
  currentUserSubject = new BehaviorSubject({});
  currentUser = this.currentUserSubject.asObservable();
  win: any = window;
  windowRef: any;
  token: string = '';

  companyCode = new BehaviorSubject('');
  companyCode$ = this.companyCode.asObservable();

  heading = signal('');

  constructor(
    private route: Router
  ) { }

  signOut(): void {
    window.localStorage.clear();
    this.route.navigate(['/signin'],);
  }

  public saveUser(user: any): void {
    const currentUser = JSON.stringify({ customerName: user.customerName, customerShortName: user.customerShortName, customerId: user.customerId, registeredOfficeContactPerson: user.registeredOfficeContactPerson, registeredOfficeEmail: user.registeredOfficeEmail, registeredOfficeMobileNo: user.registeredOfficeMobileNo, billingOfficeContactPerson: user.billingOfficeContactPerson, billingOfficeEmail: user.billingOfficeEmail, billingOfficeMobileNo: user.billingOfficeMobileNo, corporateOfficeContactPerson: user.corporateOfficeContactPerson, corporateOfficeEmail: user.corporateOfficeEmail, corporateOfficeMobileNo: user.corporateOfficeMobileNo, biilingId: user.bill_Id, corporateId: user.cor_Id, registeredId: user.reg_Id,infraCustomerCustomerId: user.infraCustomerCustomerId });
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));

    //this.cookie.set('currentUser', JSON.stringify({ userFullName: user.userFullName, role: user.role, companyId: user.companyId, companyName: user.companyName, id: user.id, designaionName: user.designaionName, employeeId: user.employeeId, employeeCode: user.employeeCode }));

    if (user.policies && user.policies.length > 0) {
      let vmsPolicy: any;
      let VendorRegPolicy: any;
      let fiberSupportPolicy: any[] = [];
      let fleetManagementPolicy: any[] = [];
      let DssPolicy: any[] = [];

      // if (user.policies.filter((x: any) => x.projectName == "Vendor").length > 0) {
      //   VendorRegPolicy = user.policies.filter((x: any) => x.projectName == "Vendor");
      //   if (VendorRegPolicy && VendorRegPolicy !== null && VendorRegPolicy.length > 0) {
      //     Cookie.set('VendorRegProjectId', VendorRegPolicy[0].projectId);
      //   }
      // }

      // if (user.policies.filter((x: any) => x.projectName == "VMS").length > 0) {
      //   vmsPolicy = user.policies.filter((x: any) => x.projectName == "VMS");
      //   if (vmsPolicy && vmsPolicy !== null && vmsPolicy.length > 0) {
      //     Cookie.set('VMSProjectId', vmsPolicy[0].projectId);
      //   }
      // }

      // if (user.policies.filter((x: any) => x.projectName == "Route Map").length > 0) {
      //   vmsPolicy = user.policies.filter((x: any) => x.projectName == "Route Map");
      //   if (vmsPolicy && vmsPolicy !== null && vmsPolicy.length > 0) {
      //     Cookie.set('RMProjectId', vmsPolicy[0].projectId);
      //   }
      // }

      // if (user.policies.filter((x: any) => x.projectName == "Fiber Support").length > 0) {
      //   fiberSupportPolicy = user.policies.filter((x: any) => x.projectName == "Fiber Support");
      //   if (fiberSupportPolicy && fiberSupportPolicy !== null && fiberSupportPolicy.length > 0) {
      //     Cookie.set('FiberSupportId', fiberSupportPolicy[0].projectId);
      //   }
      // }

      // if (user.policies.filter((x: any) => x.projectName == "Fleet Management").length > 0) {
      //   fleetManagementPolicy = user.policies.filter((x: any) => x.projectName == "Fleet Management");
      //   if (fleetManagementPolicy && fleetManagementPolicy !== null && fleetManagementPolicy.length > 0) {
      //     Cookie.set('FleetManagementId', fleetManagementPolicy[0].projectId);
      //   }
      // }

      // if (user.policies.filter((x: any) => x.projectName == "DSS").length > 0) {
      //   DssPolicy = user.policies.filter((x: any) => x.projectName == "DSS");
      //   if (DssPolicy && DssPolicy !== null && DssPolicy.length > 0) {
      //     Cookie.set('DssId', DssPolicy[0].projectId);
      //   }
      // }
    }
  }

  public getUser(): any {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return {};
  }

  public getLoginToken(): string | null {
    return window.localStorage.getItem(LOGIN_KEY);
  }

  public saveLoginToken(token: string): void {
    window.localStorage.setItem(LOGIN_KEY, token);
  }

  saveCompanyToken(token: string): void{
    window.localStorage.setItem(Company_KEY,token)
  }

  getCompanyToken(): string{
    return localStorage.getItem(Company_KEY) || '';
  }

  setCompanyCode(text: string = ''): void{
    window.localStorage.setItem('companyCode',text);
  }

  getCompanyCode(): string{
    return localStorage.getItem('companyCode') || ''
  }

  setCustomer(text: any): void{
    window.localStorage.setItem('customerDetail',JSON.stringify(text))
  } 
  getCustomer(): any{
    const data = window.localStorage.getItem('customerDetail');
    if(data){
      return JSON.parse(data) || ''
    }
  }
}
